import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";

const SelfTaskFilter = ({
    projectOptions,
    departmentOptions,
    subdepartmentOptions,
    employeeOptions,
    taskPriorityOptions,
    idcOptions,
    project,
    setProject,
    department,
    setDepartment,
    subdepartment,
    setSubDepartment,
    priority,
    setPriority,
    assignBy,
    setAssignBy,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    idcMin,
    setIdcMin,
    idcMax,
    setIdcMax,
    qwdMin,
    setQwdMin,
    qwdMax,
    setQwdMax,
    onSubmit,
    onClear,
    taskStatus,
    role
}) => {

    const selectStyle = {
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }
    };

    return (
        <Row className="mb-3 p-3 rounded bg-light">

            {/* ================= EMPLOYEE VIEW ================= */}
            {(role === "employee" || role === "teamlead" || role === "manager" || role === "humanResource") ? (
                <>
                    {/* Row 1 */}
                    <Col md={6}>
                        <Form.Label>Project</Form.Label>
                        <Select
                            options={projectOptions}
                            value={project}
                            onChange={setProject}
                            {...selectStyle}
                        />
                    </Col>

                    <Col md={6}>
                        <Form.Label>Priority</Form.Label>
                        <Select
                            options={taskPriorityOptions}
                            value={priority}
                            onChange={setPriority}
                            {...selectStyle}
                        />
                    </Col>

                    {/* Row 2 CENTER */}
                    <Col md={12} className="d-flex justify-content-center mt-3">
                        <div className="d-flex gap-3 align-items-end">

                            <div>
                                <Form.Label>Start Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>

                            <div>
                                <Form.Label>End Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    min={startDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </div>

                            <div className="d-flex gap-2">
                                <Button className="primaryBtn" onClick={onSubmit}>
                                    Submit
                                </Button>
                                <Button className="clearBtn" onClick={onClear}>
                                    Clear
                                </Button>
                            </div>

                        </div>
                    </Col>
                </>
            ) : (
                <>
                    {/* ================= ADMIN / TL VIEW ================= */}

                    <Col md={3}>
                        <Form.Label>Project</Form.Label>
                        <Select options={projectOptions} value={project} onChange={setProject} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Department</Form.Label>
                        <Select options={departmentOptions} value={department} onChange={setDepartment} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Sub Department</Form.Label>
                        <Select options={subdepartmentOptions} value={subdepartment} onChange={setSubDepartment} isDisabled={!department} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Priority</Form.Label>
                        <Select options={taskPriorityOptions} value={priority} onChange={setPriority} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Assign By</Form.Label>
                        <Select options={employeeOptions} value={assignBy} onChange={setAssignBy} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>End Date</Form.Label>
                        <Form.Control type="date" value={endDate} min={startDate} onChange={(e) => setEndDate(e.target.value)} />
                    </Col>

                    <Col md={3} className="d-flex align-items-end gap-2">
                        <Button className="primaryBtn w-50" onClick={onSubmit}>Submit</Button>
                        <Button className="clearBtn w-50" onClick={onClear}>Clear</Button>
                    </Col>
                </>
            )}

            {/* Completed filters (same for both) */}
            {/* {taskStatus === "completed" && (
                <>
                    <Col md={3}>
                        <Form.Label>Min IDC</Form.Label>
                        <Select options={idcOptions} value={idcMin} onChange={setIdcMin} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Max IDC</Form.Label>
                        <Select options={idcOptions} value={idcMax} onChange={setIdcMax} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Min QWD</Form.Label>
                        <Select options={idcOptions} value={qwdMin} onChange={setQwdMin} {...selectStyle} />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Max QWD</Form.Label>
                        <Select options={idcOptions} value={qwdMax} onChange={setQwdMax} {...selectStyle} />
                    </Col>
                </>
            )} */}

        </Row>
    );
};

export default SelfTaskFilter;